import classNames from 'classnames';
import { HighSoundIndicatorIcon, LowSoundIndicatorIcon, MediumSoundIndicatorIcon } from 'src/themes/cosmos/icons';

import styles from './styles.module.scss';

interface ISoundHeightIndicatorProps {
  volume: number;
}

const SoundHeightIndicator = ({ volume }: ISoundHeightIndicatorProps) => (
  <div data-testid='containerSoundHeightIndicator' className={classNames(styles.container)}>
    <LowSoundIndicatorIcon
      className={classNames(styles.soundIcon, styles.lowWave, { [styles.visible]: volume >= 1 })}
    />
    <MediumSoundIndicatorIcon
      className={classNames(styles.soundIcon, styles.mediumWave, { [styles.visible]: volume >= 35 })}
    />
    <HighSoundIndicatorIcon
      className={classNames(styles.soundIcon, styles.highWave, { [styles.visible]: volume >= 70 })}
    />
  </div>
);

export default SoundHeightIndicator;
